import { useEffect, useRef } from "react";
export default function useDebouncedCallback(callback, wait = 500) {
    // track args & timeout handle between calls
    const argsRef = useRef([]);
    const timeout = useRef(null);
    function cleanup() {
        if (timeout.current !== null) {
            clearTimeout(timeout.current);
        }
    }
    // make sure our timeout gets cleared if
    // our consuming component gets unmounted
    useEffect(() => cleanup, []);
    return function debouncedCallback(...args) {
        // capture latest args
        argsRef.current = args;
        // clear debounce timer
        cleanup();
        // start waiting again
        timeout.current = window.setTimeout(() => {
            if (argsRef.current) {
                callback(...argsRef.current);
            }
        }, wait);
    };
}
